var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgExpand = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.1 15.678a1.027 1.027 0 0 1-1.493 0L4.988 9.732C4.37 9.077 4.834 8 5.734 8h11.237c.901 0 1.365 1.077.747 1.731l-5.619 5.947Z",
  fill: "#B7B8BD"
})));

export { SvgExpand as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjA5OTEgMTUuNjc4NUMxMS42OTQgMTYuMTA3MiAxMS4wMTE5IDE2LjEwNzIgMTAuNjA2OCAxNS42Nzg1TDQuOTg4MjggOS43MzEzNkM0LjM2OTg4IDkuMDc2OCA0LjgzMzkzIDggNS43MzQ0MSA4TDE2Ljk3MTUgOEMxNy44NzIgOCAxOC4zMzYgOS4wNzY4IDE3LjcxNzYgOS43MzEzNkwxMi4wOTkxIDE1LjY3ODVaIiBmaWxsPSIjQjdCOEJEIi8+Cjwvc3ZnPgo=";